const customSelectors = {};
class customJS {
    constructor() {
    }
}

typeof customJS !== 'undefined' && new customJS();

$(document).ready(function(){
$(".info-icon").on("click", function() {
  var pop = $(this).data("modal");
  $(pop).show();
}); 


$(".popup").on("click", function(e) {
  var className = e.target.className;
  if( className === "close"  ){
    $(this).closest(".popup").hide();
  }
});
$(document).on('mouseup', function(e) {
  if (!$(event.target).closest(".popup").length) {
    $("div").find(".popup").hide();
  }
});

$(document).on('keyup',function(e) {
    if (e.keyCode == 27) {
      $("div").find(".popup").hide();
    }
});  
  
});




